// @ts-nocheck
import React, { useState } from "react";
import category from "util/category.js";
import { Input, Row, Col, FormGroup } from "reactstrap";
import "components/CategorySelectInput/categorySelectInput.css";

export default function CategorySelectInput() {
    const [firstCat, setFirstCat] = useState(category);
    const [secondCat, setSecondCat] = useState("");
    const [thirdCat, setThirdCat] = useState("");
    const [fourthCat, setForthCat] = useState("");
    const [subCat, setSubCat] = useState("");

    const populateCategory = (catArry) => {
        if (typeof catArry != "object")
            return <option> 상위 분류를 선택하세요 </option>;
        if (catArry.branch.length === 0) {
            return <option> 없음 </option>;
        }
        return catArry.branch.map((cat) => {
            return <option>{cat.name}</option>;
        });
    };

    const onLargeCategoryChange = (e) => {
        setSecondCat(category.branch.find((cat) => cat.name == e.target.value));
        setThirdCat("");
        setForthCat("");
        setSubCat("");
    };

    const onMediumCategoryChange = (e) => {
        if (typeof secondCat == "object") {
            setThirdCat(
                secondCat.branch.find((cat) => cat.name == e.target.value)
            );
            setForthCat("");
            setSubCat("");
        }
    };

    const onSmallCategoryChange = (e) => {
        if (typeof thirdCat == "object") {
            setForthCat(
                thirdCat.branch.find((cat) => cat.name == e.target.value)
            );
            setSubCat("");
        }
    };

    const onSubCategoryChange = (e) => {
        if (typeof fourthCat == "object") {
            setSubCat(
                fourthCat.branch.find((cat) => cat.name == e.target.value)
            );
        }
    };

    return (
        <React.Fragment>
            <Row>
                <Col lg="3">
                    <FormGroup>
                        <label className="form-control-label">
                            LargeCategory
                        </label>
                        <Input
                            type="select"
                            id="input-category-first"
                            onClick={onLargeCategoryChange}
                            onChange={onLargeCategoryChange}
                        >
                            {populateCategory(category)}
                        </Input>
                    </FormGroup>
                </Col>
                <Col lg="3">
                    <FormGroup>
                        <label className="form-control-label">
                            Medium Category
                        </label>
                        <Input
                            type="select"
                            id="input-category-second"
                            onChange={onMediumCategoryChange}
                            onClick={onMediumCategoryChange}
                        >
                            {populateCategory(secondCat)}
                        </Input>
                    </FormGroup>
                </Col>
                <Col lg="3">
                    <FormGroup>
                        <label className="form-control-label">
                            Small Category
                        </label>
                        <Input
                            type="select"
                            id="input-category-third"
                            onChange={onSmallCategoryChange}
                            onClick={onSmallCategoryChange}
                        >
                            {populateCategory(thirdCat)}
                        </Input>
                    </FormGroup>
                </Col>
                <Col lg="3">
                    <FormGroup>
                        <label className="form-control-label">
                            Sub Category
                        </label>
                        <Input
                            type="select"
                            id="input-category-fourth"
                            onChange={onSubCategoryChange}
                            onClick={onSubCategoryChange}
                        >
                            {populateCategory(fourthCat)}
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
        </React.Fragment>
    );
}
